import styled from 'styled-components';

export const StyledButton = styled.button`
  width: 70%;
  height: 40px;
  background-color: #30435d;
  border-radius: 3px;
  color: white;
  :disabled {
    opacity: 0.5;
  }
`;
export const SaveButton = styled.button`
  width: 132px;
  height: 40px;
  font-weight: 700;
  font-size: 14px;
  background-color: #30435d;
  border-radius: 3px;
  color: white;
  :disabled {
    opacity: 0.5;
  }
`;
export const CancelButton = styled.button`
  width: 132px;
  height: 40px;
  border-radius: 3px;
  color: #30435d;
  font-weight: 700;
  font-size: 14px;
  :disabled {
    opacity: 0.5;
  }
`;
export const ResetButton = styled.button`
  width: 30%;
  height: 40px;
  border-radius: 3px;
  background-color: #fff !important;
  color: #30435d !important;
  margin-right: 10px;
  font-weight: bold;
  font-size: 14px;
  border: 1px solid #000000;
  :disabled {
    opacity: 0.5;
  }
`;
export const MarketButton = styled.button`
  width: 84px;
  height: 26px;
  border-radius: 3px;
  background-color: #fff !important;
  color: #30435d !important;
  font-weight: 400;
  font-size: 14px;
  border: 1px solid #000000;
  :disabled {
    opacity: 0.5;
  }
`;
export const GenerateButton = styled.button`
  width: 48%;
  height: 36px;
  border-radius: 3px;
  background-color: #eeeeee !important;
  color: #30435d !important;
  font-weight: 400;
  font-size: 14px;
  border: 1px solid #000000;
  :disabled {
    opacity: 0.5;
  }
`;

export const GenerateButtonMemri = styled.button`
  width: 45%;
  margin-top: 15px;
  height: 36px;
  border-radius: 3px;
  background-color: #eeeeee !important;
  color: #30435d !important;
  font-weight: 400;
  font-size: 14px;
  border: 1px solid #000000;
  :disabled {
    opacity: 0.5;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: right;
`;

export const ModalContainer = styled.div`
  margin: 12px;
`;

export const RldConfirmButton = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  text-align: center;
`;

export const SubscriptionSeats = styled.span`
  color: #707a86;
  padding-left: 9px;
  display: inline-block;
  font-weight: 400;
  background-color: #e2ecf9;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
